import React, { useState } from 'react';
import { Form, Button, Modal, Alert } from "react-bootstrap";
import Select from 'react-select';
import axios from 'axios';
import { FileUploader } from '../../../../components/ImageUploader';
import { API_URL } from '../../../../constants';
import { toast } from 'react-toastify';

const AddBirthdayCard = ({ show, handleClose, fetchAppraisal, EmployeeListdata }) => {
    const [profilePic, setProfilePic] = useState('https://via.placeholder.com/150');
    const [fileName, setFileName] = useState("");
    const [formData, setFormData] = useState({
        selectedOption: null,
        checkedItems: []
    });
    const [errorMessage, setErrorMessage] = useState("");
    const [value, setValue] = useState(null);

    const resetFormState = () => {
        setValue(null);
        setFileName("");
        setProfilePic("https://via.placeholder.com/150");
        setFormData({
            selectedOption: null,
            checkedItems: []
        });
        setErrorMessage("");
    };

    const handleFile = (file) => {
        const fileType = file.type;
        const fileSize = file.size;
        if (fileType !== 'image/png' && fileType !== 'image/jpeg') {
            setErrorMessage("Only PNG and JPEG formats are allowed.");
            return;
        }
        if (fileSize > 300 * 1024) { // 300 KB
            setErrorMessage("File size should be less than 300 KB.");
            return;
        }
        setErrorMessage("");
        setFileName(file.name);
        const previewUrl = URL.createObjectURL(file);
        setProfilePic(previewUrl);
        setFormData(prevState => ({
            ...prevState,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!value || !fileName) {
            setErrorMessage("Please select an employee and upload an image.");
            return;
        }
        const data = new FormData();
        data.append('EmployeeID', value.value);
        data.append('BirthdayImage', fileName);

        try {
            await axios.post(`${API_URL}birthday-card-store`, data);
            toast.success("Data submitted successfully!");
            handleClose();
            fetchAppraisal(); // Refresh the table data
        } catch (error) {
            setErrorMessage("Error submitting data.");
            toast.error("Error submitting data.");
            console.error('Error submitting data:', error);
        }
    };

    return (
        <>
          <Form onSubmit={handleSubmit}>
                    <div className='row'>
                        <div className="col-6 text-center">
                            <div className="profile-pic-container mb-3">
                                <p>*Upload photo size should be less than 300KB</p>
                                <img id="profilePic" className="profile-pic" src={profilePic} alt="Birthday Pic" />
                                <div className='mt-2'>
                                    <FileUploader handleFile={handleFile} />
                                    {fileName ? <p>Upload: {fileName}</p> : null}
                                    {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="col-12 mt-1">
                                <label htmlFor="refercandidatelist" className="form-label mt-1">
                                    Employee Name
                                </label>
                                <div>
                                    <Select
                                        className="basic-single"
                                        classNamePrefix="select"
                                        value={value}
                                        onChange={setValue}
                                        options={EmployeeListdata}
                                        placeholder="Select Employee"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-12 text-right">
                            <Button type="submit" className="btn btn-info pull-right">
                                Submit
                            </Button>
                        </div>
                    </div>
                </Form></>
        // <Modal show={show} onHide={handleClose} className='custom-modal'>
        //     <Modal.Header closeButton>
        //         <Modal.Title>
        //             <h4>Birthday Details</h4>
        //         </Modal.Title>
        //     </Modal.Header>
        //     <Modal.Body>
        //         <Form onSubmit={handleSubmit}>
        //             <div className='row'>
        //                 <div className="col-6 text-center">
        //                     <div className="profile-pic-container mb-3">
        //                         <p>*Upload photo size should be less than 300KB</p>
        //                         <img id="profilePic" className="profile-pic" src={profilePic} alt="Profile Pic" />
        //                         <div className='mt-2'>
        //                             <FileUploader handleFile={handleFile} />
        //                             {fileName ? <p>Upload: {fileName}</p> : null}
        //                             {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
        //                         </div>
        //                     </div>
        //                 </div>
        //                 <div className="col-6">
        //                     <div className="col-12 mt-1">
        //                         <label htmlFor="refercandidatelist" className="form-label mt-1">
        //                             Employee Name
        //                         </label>
        //                         <div>
        //                             <Select
        //                                 className="basic-single"
        //                                 classNamePrefix="select"
        //                                 value={value}
        //                                 onChange={setValue}
        //                                 options={EmployeeListdata}
        //                                 placeholder="Select Employee"
        //                             />
        //                         </div>
        //                     </div>
        //                 </div>
        //             </div>
        //             <div className="row mt-3">
        //                 <div className="col-12 text-right">
        //                     <Button type="submit" className="btn btn-info pull-right">
        //                         Submit
        //                     </Button>
        //                 </div>
        //             </div>
        //         </Form>
        //     </Modal.Body>
        // </Modal>
    );
}

export default AddBirthdayCard;
